import React from 'react';
import styled from 'styled-components';
import { FormattedMessage } from 'react-intl';

import { Container, Section } from '../global';

const StyledSection = styled(Section)`
  background-color: ${(props) => props.theme.color.background.light};
  /* clip-path: polygon(0 7%, 100% 4%, 100% 100%, 0% 100%); */
  /* clip-path: polygon(0 0, 100% 14%, 100% 100%, 0% 100%); */
`;

const StyledContainer = styled(Container)`
  display: flex;
  justify-content: center;
  align-items: center;
  flex-direction: column;
  padding: 20px 10px 40px 10px;
`;

const GetStartedTitle = styled.h3`
  margin: 0 auto 32px;
  text-align: center;
`;

const SubHeader = styled.p`
  && {
    font-family: ${(props) => props.theme.font.bold};
    font-weight: ${(props) => props.theme.font_weight.bold};
    ${(props) => props.theme.font_size.xsmall};
  }
`;

const Paragraph = styled.p`
  && {
    ${(props) => props.theme.font_size.xxsmall};
  }
`;

const Contact = () => (
  <StyledSection id="contact">
    <StyledContainer>
      <FormattedMessage
        id="contact"
        values={{
          GetStartedTitle: (...chunks) => (
            <GetStartedTitle>{chunks}</GetStartedTitle>
          ),
          SubHeader: (...chunks) => <SubHeader>{chunks}</SubHeader>,
          Paragraph: (...chunks) => <Paragraph>{chunks}</Paragraph>,
        }}
      />

      <br />
      <FormattedMessage
        id="companyDetails"
        values={{
          SubHeader: (...chunks) => <SubHeader>{chunks}</SubHeader>,
          Paragraph: (...chunks) => <Paragraph>{chunks}</Paragraph>,
        }}
      />
    </StyledContainer>
  </StyledSection>
);

export default Contact;
